import React, { useEffect, useState } from 'react';
import Page from '../../../components/Page/Page';
import {
  BaseQueryParamsType,
  ProductCategoriesQueryParamsType,
  SearchArgsType,
} from '../../../redux/_types';
import { useTypedDispatch, useTypedSelector } from '../../../redux/hooks';
import { getSearchParameters } from '../../../utils/queryParams';
import { convertQueryParamsToSearchArgs } from '../../../redux/_helpers';
import SearchContent from '../../../components/SearchContent/SearchContent';
import Spinner from '../../../components/Spinner/Spinner';
import { AnalyticEventsEnum, trackEvent } from '../../../Analytics';
import { useIonViewDidEnter } from '@ionic/react';
import { usePointLocation } from '../../../hooks/hook.location';

const UserCatalogPage = () => {
  const dispatch = useTypedDispatch();
  const pointLocation = usePointLocation();
  const lockedLocation = useTypedSelector(s => s.location.lockedLocation);

  const location = lockedLocation || pointLocation;

  const eventCategories = useTypedSelector(s => s.choices.eventCategorySet);
  const productCategories = useTypedSelector(s => s.choices.productCategorySet);

  const [initialSearchArgs, setInitialSearchArgs] = useState<SearchArgsType>();

  useEffect(() => {
    if (!eventCategories.length || !productCategories.length || !location) {
      return;
    }

    const queryParams: BaseQueryParamsType & ProductCategoriesQueryParamsType =
      getSearchParameters();

    const providedSearchArgs = convertQueryParamsToSearchArgs(
      queryParams,
      eventCategories,
      productCategories,
      location
    );

    setInitialSearchArgs(providedSearchArgs);
  }, [dispatch, eventCategories, productCategories, location]);

  useIonViewDidEnter(() => {
    (async function () {
      await Promise.all([
        trackEvent(AnalyticEventsEnum.VIEW_CONTENT),
        trackEvent(AnalyticEventsEnum.VIEW__CATALOG),
      ]);
    })();
  }, []);

  return (
    <Page
      disableDefaultIonContent
      pageLimitDisabled
      headerProps={{
        hideBackButton: true,
        showLocationPicker: true,
      }}
    >
      {!initialSearchArgs ? (
        <Spinner hasCountdown />
      ) : (
        <SearchContent key="catalog" initialSearchArgs={initialSearchArgs} />
      )}
    </Page>
  );
};

export default React.memo(UserCatalogPage);
